<template>
  <div class="outer screen text-center">
    <div class="center content-wrap">
      <div v-if="!hasPersonalData">
        <PersonalDataScreen />
      </div>
      <div v-if="hasPersonalData && !hasQuestionOne">
        <QuestionOneScreen />
      </div>

      <div v-if="mustAnswerWhyNoApp">
        <QuestionFourScreen />
      </div>

      <div v-if="canContinueToGdpr && !hasQuestionGdpr">
        <QuestionGdprScreen />
      </div>
      <div v-if="hasQuestionGdpr && hasSavedData">
        <QrCodeScreen />
      </div>
      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
import PersonalDataScreen from "@/components/PersonalDataScreen.vue";
import QuestionOneScreen from "@/components/QuestionOneScreen.vue";
import QuestionFourScreen from "@/components/QuestionFourScreen.vue";
import QuestionGdprScreen from "@/components/QuestionGdprScreen.vue";
import QrCodeScreen from "@/components/QrCodeScreen.vue";

export default {
  name: "HomeView",
  components: {
    PersonalDataScreen,
    QuestionOneScreen,
    QuestionFourScreen,
    QuestionGdprScreen,
    QrCodeScreen,
  },
  computed: {
    hasPersonalData: function () {
      const firstName = this.$store.getters.getFirstName;
      const lastName = this.$store.getters.getLastName;
      const email = this.$store.getters.getEmail;
      return firstName !== "" && lastName !== "" && email !== "";
    },
    hasQuestionOne: function () {
      if (this.$store.getters.getQuestionOne === null) {
        return false;
      }
      return true;
    },
    mustAnswerWhyNoApp: function () {
      return (
        this.$store.getters.getQuestionOne === "Nee" &&
        this.$store.getters.getQuestionTwo === null
      );
    },
    canContinueToGdpr: function () {
      const appAnswer = this.$store.getters.getQuestionOne;
      const reason = this.$store.getters.getQuestionTwo;

      if (appAnswer === "Ja") {
        return true;
      }

      if (appAnswer === "Nee" && reason !== null && reason !== "") {
        return true;
      }

      return false;
    },
    hasQuestionGdpr: function () {
      if (this.$store.getters.getQuestionGdpr === null) {
        return false;
      }
      return true;
    },
    hasSavedData: function () {
      if (this.$store.getters.getSavedData === null) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.outer {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 16px;
  background: #db011c;
}

.center {
  width: 100%;
  max-width: 100%;
}

.content-wrap {
  width: 100%;
  max-width: 100%;
  background: transparent;
  padding: 20px 16px;
}

.bottom-spacer {
  height: 0;
}

@media (min-width: 768px) {
  .outer {
    padding: 32px 16px;
  }

  .content-wrap {
    max-width: 600px;
    padding: 32px 28px;
  }
}
</style>
